import type { UserAnalysisQuotasData } from '@/features/analysisPage/types';
import type { GetCurrentUserAnalysisQuotasQuery } from '@/shared/api/types/generated';

export function mapUserAnalysisQuotasData(
  data: GetCurrentUserAnalysisQuotasQuery['getCurrentUserAnalysisQuotas'],
): UserAnalysisQuotasData {
  return {
    hasPublicAnalysisAccess: data.hasPartialPublicAnalysisAccess,
    canCreateProductAnalysis: data.canCreateCatalogAnalysis,
    productAnalysesMax: data.catalogAnalysesMax,
    canCreateVendorAnalysis: data.canCreateProfileAnalysis,
    vendorAnalysesMax: data.profileAnalysesMax,
  };
}
